/** All available debt collection task statuses */
export enum DebtCollectionTaskStatusEnum {
  /** New debt collection task */
  NEW = 'NEW',
  /** Debt collection task in progress */
  IN_PROGRESS = 'IN_PROGRESS',
  /** Debt collection task completed */
  COMPLETED = 'COMPLETED',
}
